import AnalyticsState from "../data/state/AnalyticsState";

function AnalyticsReducer(state, action) {
    switch (action.type) {
        case "setResultInformation": {
            return { ...state, ...action.payload };
        }

        case "resetState": {
            return AnalyticsState;
        }

        case "SET_CLICKED_LABEL": {
            return { ...state, clickedLabel: action.payload };
        }

        case "SET_CLICKED_TIME": {
            if (action.payload === null) {
                return { ...state, clickedTime: null, clickedDate: null };
            }
            return {
                ...state,
                clickedTime: action.payload.time,
                clickedDate: action.payload.date,
            };
        }

        case "SET_LOADING": {
            return { ...state, isLoading: action.payload };
        }

        case "RESET_CLICKED_STATES": {
            return {
                ...state,
                clickedLabel: null,
                clickedTime: null,
            };
        }

        case "SET_VIEW":
            return { ...state, view: action.payload };

        case "RESET_VIEW_TO_DATES":
            return { ...state, view: "dates" };

        default: {
            throw new Error("unhandled action");
        }
    }
}

export default AnalyticsReducer;
